<template>
  <div class="table">
    <artmisads-table :columns="columns" row-key="id" :scroll="{ x: props.activeTab === '0' ? 1300 : props.activeTab === '2' ? 900 : 1000,y: 500 }"
      :data-source="props.dataList" :pagination="{
        total: props.tableTotal,
        current: props.params.page,
        pageSize: props.params.size,
        showSizeChanger: true,
      pageSizeOptions: ['10', '20', '50', '100', '200']
    }" :change="onChangePage" rowClassName="table-item">
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.name === 'showCurrency'">
          {{ text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : '' }}{{ text }}
        </template>
        <template v-if="column.name === 'reportDateTimestamp'">
          {{ moment(text).format('YYYY-MM-DD') }}
        </template>
        <template v-if="column.name === 'more'">
          <svg @click="() => onClickTableChart(record)" class="icon chart-icon" aria-hidden="true">
            <use xlink:href="#icon-chart"></use>
          </svg>
        </template>
        <template v-if="column.name === 'ACOS'">
          {{ text ? (text * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : '0' }}
        </template>
        <template v-if="column.name === 'brandName'">
          <a class="brand-title" target="_blank" >
            <div class="brand-img-show" :style="record?.brandLogoImageUrl ? { 'background': '#ffffff' } : ''">
              <img :src="record.brandLogoImageUrl" v-if="record.brandLogoImageUrl">
              <span class="brand-name" v-else>{{ record.brandName }}</span>
            </div>
            <div class="brand-font">
              <span >{{ record.brandName }}</span>
            </div>
          </a>
        </template>
      </template>

      <template #summary>
        <a-table-summary-row>
          <a-table-summary-cell class="fixed-left">Total</a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalDetailPageViews }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalAddToCart }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalConversions }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '1'">
            <a-typography-text>{{ props.tagNumParams.totalQuantity }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '2'">
            <a-typography-text>{{ props.tagNumParams.totalClicks }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '2'">
            <a-typography-text>{{ props.tagNumParams.totalOrders ?? props.tagNumParams.totalConversions ?? 0 }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text>{{ props.tagNumParams.totalSalesAmount ? AMAZON_CURRENCY_MAPPER[props.marketplace] :
              '' }}{{ props.tagNumParams.totalSalesAmount }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalAcos ? (props.tagNumParams.totalAcos *
              100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : 0 }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalDiscountedSalesAmount ?
              AMAZON_CURRENCY_MAPPER[props.marketplace] : '' }}{{ props.tagNumParams.totalDiscountedSalesAmount
              }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0' || props.activeTab === '1'">
            <a-typography-text>{{ props.tagNumParams.totalCommissionAndFeeAmount ?
              AMAZON_CURRENCY_MAPPER[props.marketplace] : '' }}{{ props.tagNumParams.totalCommissionAndFeeAmount
              }}</a-typography-text>
          </a-table-summary-cell>
         <a-table-summary-cell v-if="props.activeTab === '1'">
            <a-typography-text>
               {{
                props.tagNumParams.totalFinalCommissionAndFeeAmount
                  ? AMAZON_CURRENCY_MAPPER[props.marketplace]
                  : ''
              }}
              {{
              props.tagNumParams.totalFinalCommissionAndFeeAmount
            }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '2'">
            <a-typography-text>{{ props.tagNumParams.totalBonusAmount ?
              AMAZON_CURRENCY_MAPPER[props.marketplace] : '' }}{{ props.tagNumParams.totalBonusAmount
              }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text></a-typography-text>
          </a-table-summary-cell>
        </a-table-summary-row>
      </template>
    </artmisads-table>
  </div>
</template>
<script setup lang="jsx">
import moment from 'moment'
import { computed } from 'vue'
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'

const props = defineProps(['dataList', 'activeTab', 'marketplace', 'tableTotal', 'params', 'setParams', 'onClickTableChart', 'tagNumParams'])

const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data
  let newParams = { ...props.params }
  newParams.page = current
  newParams.size = pageSize
  if (sorter) {
    const { field, order } = sorter
    newParams.sortField = field
    newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc'
  } else {
    newParams.sortField = ''
    newParams.sortDirection = ''
  }
  props.setParams(newParams)
}

const columns = computed(() => {
  if (props.activeTab === '2') {
    return [
      {
        title: 'Brand',
        dataIndex: 'brandName',
        name: 'brandName',
      },
      {
        title: 'Clicks',
        dataIndex: 'clicks',
        sorter: true,
      },
      {
        title: 'Orders',
        dataIndex: 'orders',
        sorter: true,
      },
      {
        title: 'Sales',
        dataIndex: 'salesAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'Bonus',
        dataIndex: 'bonusAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'More',
        name: 'more',
        dataIndex: 'bonusAmount',
        width: 70,
        fixed: 'right',
      },
    ]
  }
  if (props.activeTab === '1') {
    return [
      {
        title: 'Brand',
        dataIndex: 'brandName',
        name: 'brandName',
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        sorter: true,
      },
      {
        title: 'Sales',
        dataIndex: 'salesAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'Commission',
        dataIndex: 'commissionAndFeeAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'Adjusted Commission By ACC',
        dataIndex: 'finalCommissionAndFeeAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'More',
        name: 'more',
        dataIndex: 'commissionAndFeeAmount',
        width: 70,
        fixed: 'right',
      },
    ]
  }
  return [
    {
      title: 'Brand',
      dataIndex: 'brandName',
      name: 'brandName',
      width: 170,
      fixed: 'left',
    },
    {
      title: 'DPVs',
      dataIndex: 'detailPageViews',
      width: 80,
      sorter: true,
    },
    {
      title: 'Add to Cart',
      dataIndex: 'addToCart',
      width: 130,
      sorter: true,
    },
    {
      title: 'Conversions',
      dataIndex: 'conversions',
      width: 120,
      sorter: true,
    },
    {
      title: 'Sales',
      dataIndex: 'salesAmount',
      name: 'showCurrency',
      width: 100,
      sorter: true,
    },
    {
      name: 'ACOS',
      title: 'ACOS',
      dataIndex: 'acos',
      width: 100,
      sorter: true,
    },
    {
      title: 'Sales for Commission',
      dataIndex: 'discountedSalesAmount',
      name: 'showCurrency',
      width: 200,
      sorter: true,
    },
    {
      title: 'Commission',
      dataIndex: 'commissionAndFeeAmount',
      name: 'showCurrency',
      width: 120,
      sorter: true,
    },
    {
      title: 'More',
      name: 'more',
      dataIndex: 'commissionAndFeeAmount',
      width: 70,
      fixed: 'right',
    },
  ]
})
</script>
<style lang="less" scoped>
.brand-name {
  margin: 0 auto;
  padding: 0 4px;
  max-width: 56px;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 39px;
  font-weight: 600;
  line-height: 13px;
  text-align: center;
  color: var(--dark-4);
  letter-spacing: 0.3px;
  word-break: break-all !important;
}
:deep(.ant-table) {
  .brand-title {
    display: flex;
    align-items: center;
    .brand-font {
      word-break: break-all;
      flex: 1;
      margin-left: 12px;
      font-weight: 500;
      color: var(--dark-1);
      letter-spacing: 0.4px;
      line-height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-decoration: underline;
    }
    .brand-img-show {
      width: 56px;
      height: 56px;
      background: var(--bg-gray-2);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      :deep(img) {
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .chart-icon {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
  .inactive-commission {
    color: var(--dark-4);
  }
  .status-text {
    text-transform: capitalize;
  }
}
.fixed-left {
  left: 0;
  z-index: 1;
  position: sticky;
  padding-left: 86px;
}
</style>
